import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleDetail from "../pages/article/ArticleDetail";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/basetao-spreadsheet-guide-2026",
    element: <ArticlePage />,
  },
  {
    path: "/article/basetao-review-2026",
    element: <ArticleDetail />,
  },
  {
    path: "/article/basetao-shipping-cost-guide",
    element: <ArticleDetail />,
  },
  {
    path: "/article/basetao-coupon-discount-code",
    element: <ArticleDetail />,
  },
  {
    path: "/article/basetao-warehouse-guide",
    element: <ArticleDetail />,
  },
  {
    path: "/article/is-basetao-safe",
    element: <ArticleDetail />,
  },
  {
    path: "/article/basetao-alternatives",
    element: <ArticleDetail />,
  },
  {
    path: "/article/basetao-qc-guide",
    element: <ArticleDetail />,
  },
  {
    path: "/article/basetao-beginners",
    element: <ArticleDetail />,
  },
  {
    path: "/article/best-basetao-finds",
    element: <ArticleDetail />,
  },
  {
    path: "/article/basetao-shipping-calculator",
    element: <ArticleDetail />,
  },
  {
    path: "/article/basetao-tracking",
    element: <ArticleDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;